import rightImg from "images/about.png";
import { FC } from "react";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import ReadytoDrive from "./ReadytoDrive";
import readytodrive from "images/readytodrive.png";
import DriveLuxury from "components/DriveLuxury/DriveLuxury";
import WhyChooseUS from "containers/StartEarning/WhyUs";
import BestServices from "components/LocationSection/LocationSection";
import StepsSection from "components/Steps/Steps";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About</title>
      </Helmet>

      <div className="container relative py-16">
        <DriveLuxury />
      </div>
      <div className="container relative py-16">
        <StepsSection />
      </div>

      <div className="container py-16">
        <div className="  rounded-2xl bg-[#FFFFFF0D]">
          <div className="relative pt-16 pb-5">
            <SectionClientSay uniqueClassName="PageAbout_" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAbout;
